import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

import { namespace as AddressNamespace } from './address/slice';
import { namespace as AuthenticationNamespace } from './authentication/slice';

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: [AddressNamespace, AuthenticationNamespace],
  blacklist: [],
};

const root = persistReducer(persistConfig, rootReducer);
export const sagaMiddleware = createSagaMiddleware();
const middleware = [createStateSyncMiddleware(persistConfig), sagaMiddleware];
export const store = configureStore({
  reducer: root,
  middleware: middleware,
  devTools: process.env.NODE_ENV !== 'production',
});
initMessageListener(store);
sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store, {});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
